/*
 * Created on Wed Sep 21 2022
 *
 * Copyright (c) 2021 Cohart Inc - All Rights Reserved
 * Unauthorized copying of this file via any medium is strictly prohibited
 * Proprietary and confidential
 * Copyright terms written by Cohart Inc <support@cohart.co>, Wed Sep 21 2022
 */

import { RefObject, useEffect } from 'react'

type OnClickOutsideType = {
  ref: RefObject<HTMLDivElement | HTMLLabelElement>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handler: (event: any) => void
}

const useOnClickOutside = ({ ref, handler }: OnClickOutsideType) => {
  useEffect(
    () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const listener = (event: any) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return
        }
        handler(event)
      }
      document.addEventListener('mousedown', listener)
      document.addEventListener('touchstart', listener)
      return () => {
        document.removeEventListener('mousedown', listener)
        document.removeEventListener('touchstart', listener)
      }
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler],
  )
}

export default useOnClickOutside
